import ACTUALIZAR_MINUTA_ACUERDO from '@/graphql/mutations/administracion/minutas/acuerdos/actualizarContratoMinutaAcuerdo.gql';
import CONTRATOS_MINUTAS_ACUERDOS_VENCIDOS from '@/graphql/querys/administracion/minutas/contratoMinutasAcuerdosVencidos.gql';

export default {
  methods: {
    async mixEditarAcuerdo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const { id } = this.acuerdo;
      const acuerdo = this.minutaAcuerdoEditar;
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_MINUTA_ACUERDO,
        variables: {
          id,
          minutaAcuerdo: acuerdo,
        },
        update: (store, { data: { actualizarContratoMinutaAcuerdo } }) => {
          const data = store
            .readQuery({
              query: CONTRATOS_MINUTAS_ACUERDOS_VENCIDOS,
              variables: {
                numeroRegistros: null,
                pagina: null,
              },
            });
          const { contratoMinutasAcuerdosVencidos } = data;
          const index = contratoMinutasAcuerdosVencidos
            .findIndex((a) => a.id === actualizarContratoMinutaAcuerdo.id);
          if (index !== -1) {
            contratoMinutasAcuerdosVencidos.splice(index, 1, actualizarContratoMinutaAcuerdo);
          }
          store.writeQuery({
            query: CONTRATOS_MINUTAS_ACUERDOS_VENCIDOS,
            variables: {
              numeroRegistros: null,
              pagina: null,
            },
            data,
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      // this.cerrar();
    },
  },
};
